(() => {
  'use strict';

  const SELECTOR = '[data-nbe-comments]';

  // Głosowanie: przełącza stan przycisku i licznik
  const setVote = (btn, delta, pressed) => {
    const n = btn.querySelector('.nbe-vote__n');
    if (n) n.textContent = String((parseInt(n.textContent, 10) || 0) + delta);
    btn.setAttribute('aria-pressed', String(pressed));
  };

  const handleVote = (btn) => {
    const comment = btn.closest('.nbe-comment');
    if (!comment) return;
    const other = comment.querySelector(btn.classList.contains('nbe-vote--up') ? '.nbe-vote--down' : '.nbe-vote--up');
    const active = btn.getAttribute('aria-pressed') === 'true';

    if (active) {
      setVote(btn, -1, false);
    } else {
      if (other && other.getAttribute('aria-pressed') === 'true') setVote(other, -1, false);
      setVote(btn, 1, true);
    }
  };

  const handleToggle = (btn) => {
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    const open = panel.hidden;
    panel.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
    const label = open ? btn.dataset.openLabel : btn.dataset.closedLabel;
    if (label) btn.textContent = label;
  };

  const handleMore = (btn, root) => {
    const items = root.querySelectorAll('[data-nbe-more-item]');
    let first = null;
    items.forEach((item) => {
      if (item.hidden) {
        item.hidden = false;
        if (!first) first = item;
      }
    });
    btn.hidden = true;
    if (first) {
      first.setAttribute('tabindex', '-1');
      first.focus({ preventScroll: true });
    }
  };

  const handleTab = (tab, root) => {
    root.querySelectorAll('.nbe-comments__tab').forEach((t) => {
      const on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', String(on));
    });
  };

  const handleReply = (root) => {
    const form = root.querySelector('.nbe-comments__form');
    if (!form) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    form.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  };

  const onClick = (root) => (event) => {
    const t = event.target;
    const toggle = t.closest('.nbe-thread__toggle');
    if (toggle && root.contains(toggle)) return handleToggle(toggle);

    const more = t.closest('[data-nbe-more]');
    if (more && root.contains(more)) return handleMore(more, root);

    const vote = t.closest('.nbe-vote');
    if (vote && root.contains(vote)) return handleVote(vote);

    const tab = t.closest('.nbe-comments__tab');
    if (tab && root.contains(tab)) return handleTab(tab, root);

    const reply = t.closest('.nbe-comment__reply');
    if (reply && root.contains(reply)) handleReply(root);
  };

  const init = (root) => {
    if (!root || root.dataset.nbeReady === 'true') return;
    root.dataset.nbeReady = 'true';
    root.addEventListener('click', onClick(root));
  };

  const initAll = (scope) => {
    (scope || document).querySelectorAll(SELECTOR).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Edytor motywu Shopify: ponowna inicjalizacja po przeładowaniu sekcji
  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (target.matches && target.matches(SELECTOR)) init(target);
    else initAll(target);
  });
})();